const nationalities = [{
    "id": 1,
    "Name": "Albanian"
  },
  {
    "id": 2,
    "Name": "Algerian"
  },
  {
    "id": 3,
    "Name": "American"
  },
  {
    "id": 4,
    "Name": "Andorran"
  },
  {
    "id": 5,
    "Name": "Angolan"
  },
  {
    "id": 6,
    "Name": "Antiguans"
  },
  {
    "id": 7,
    "Name": "Argentinean"
  },
  {
    "id": 8,
    "Name": "Armenian"
  },
  {
    "id": 9,
    "Name": "Australian"
  },
  {
    "id": 10,
    "Name": "Austrian"
  },
  {
    "id": 11,
    "Name": "Azerbaijani"
  },
  {
    "id": 12,
    "Name": "Bahamian"
  },
  {
    "id": 13,
    "Name": "Bahraini"
  },
  {
    "id": 14,
    "Name": "Bangladeshi"
  },
  {
    "id": 15,
    "Name": "Barbadian"
  },
  {
    "id": 16,
    "Name": "Barbudans"
  },
  {
    "id": 17,
    "Name": "Batswana"
  },
  {
    "id": 18,
    "Name": "Belarusian"
  },
  {
    "id": 19,
    "Name": "Belgian"
  },
  {
    "id": 20,
    "Name": "Belizean"
  },
  {
    "id": 21,
    "Name": "Beninese"
  },
  {
    "id": 22,
    "Name": "Bhutanese"
  },
  {
    "id": 23,
    "Name": "Bolivian"
  },
  {
    "id": 24,
    "Name": "Bosnian"
  },
  {
    "id": 25,
    "Name": "Brazilian"
  },
  {
    "id": 26,
    "Name": "British"
  },
  {
    "id": 27,
    "Name": "Bruneian"
  },
  {
    "id": 28,
    "Name": "Bulgarian"
  },
  {
    "id": 29,
    "Name": "Burkinabe"
  },
  {
    "id": 30,
    "Name": "Burmese"
  },
  {
    "id": 31,
    "Name": "Burundian"
  },
  {
    "id": 32,
    "Name": "Cambodian"
  },
  {
    "id": 33,
    "Name": "Cameroonian"
  },
  {
    "id": 34,
    "Name": "Canadian"
  },
  {
    "id": 35,
    "Name": "Cape Verdean"
  },
  {
    "id": 36,
    "Name": "Central African"
  },
  {
    "id": 37,
    "Name": "Chadian"
  },
  {
    "id": 38,
    "Name": "Chilean"
  },
  {
    "id": 39,
    "Name": "Chinese"
  },
  {
    "id": 40,
    "Name": "Colombian"
  },
  {
    "id": 41,
    "Name": "Comoran"
  },
  {
    "id": 42,
    "Name": "Congolese"
  },
  {
    "id": 43,
    "Name": "Costa Rican"
  },
  {
    "id": 44,
    "Name": "Croatian"
  },
  {
    "id": 45,
    "Name": "Cuban"
  },
  {
    "id": 46,
    "Name": "Cypriot"
  },
  {
    "id": 47,
    "Name": "Czech"
  },
  {
    "id": 48,
    "Name": "Danish"
  },
  {
    "id": 49,
    "Name": "Djibouti"
  },
  {
    "id": 50,
    "Name": "Dominican"
  },
  {
    "id": 51,
    "Name": "Dutch"
  },
  {
    "id": 52,
    "Name": "East Timorese"
  },
  {
    "id": 53,
    "Name": "Ecuadorean"
  },
  {
    "id": 54,
    "Name": "Egyptian"
  },
  {
    "id": 55,
    "Name": "Emirian"
  },
  {
    "id": 56,
    "Name": "Equatorial Guinean"
  },
  {
    "id": 57,
    "Name": "Eritrean"
  },
  {
    "id": 58,
    "Name": "Estonian"
  },
  {
    "id": 59,
    "Name": "Ethiopian"
  },
  {
    "id": 60,
    "Name": "Fijian"
  },
  {
    "id": 61,
    "Name": "Filipino"
  },
  {
    "id": 62,
    "Name": "Finnish"
  },
  {
    "id": 63,
    "Name": "French"
  },
  {
    "id": 64,
    "Name": "Gabonese"
  },
  {
    "id": 65,
    "Name": "Gambian"
  },
  {
    "id": 66,
    "Name": "Georgian"
  },
  {
    "id": 67,
    "Name": "German"
  },
  {
    "id": 68,
    "Name": "Ghanaian"
  },
  {
    "id": 69,
    "Name": "Greek"
  },
  {
    "id": 70,
    "Name": "Grenadian"
  },
  {
    "id": 71,
    "Name": "Guatemalan"
  },
  {
    "id": 72,
    "Name": "Guinea-Bissauan"
  },
  {
    "id": 73,
    "Name": "Guinean"
  },
  {
    "id": 74,
    "Name": "Guyanese"
  },
  {
    "id": 75,
    "Name": "Haitian"
  },
  {
    "id": 76,
    "Name": "Herzegovinian"
  },
  {
    "id": 77,
    "Name": "Honduran"
  },
  {
    "id": 78,
    "Name": "Hungarian"
  },
  {
    "id": 79,
    "Name": "I-Kiribati"
  },
  {
    "id": 80,
    "Name": "Icelander"
  },
  {
    "id": 81,
    "Name": "Indian"
  },
  {
    "id": 82,
    "Name": "Indonesian"
  },
  {
    "id": 83,
    "Name": "Iranian"
  },
  {
    "id": 84,
    "Name": "Iraqi"
  },
  {
    "id": 85,
    "Name": "Irish"
  },
  {
    "id": 86,
    "Name": "Israeli"
  },
  {
    "id": 87,
    "Name": "Italian"
  },
  {
    "id": 88,
    "Name": "Ivorian"
  },
  {
    "id": 89,
    "Name": "Jamaican"
  },
  {
    "id": 90,
    "Name": "Japanese"
  },
  {
    "id": 91,
    "Name": "Jordanian"
  },
  {
    "id": 92,
    "Name": "Kazakhstani"
  },
  {
    "id": 93,
    "Name": "Kenyan"
  },
  {
    "id": 94,
    "Name": "Kittian and Nevisian"
  },
  {
    "id": 95,
    "Name": "Kuwaiti"
  },
  {
    "id": 96,
    "Name": "Kyrgyz"
  },
  {
    "id": 97,
    "Name": "Laotian"
  },
  {
    "id": 98,
    "Name": "Latvian"
  },
  {
    "id": 99,
    "Name": "Lebanese"
  },
  {
    "id": 100,
    "Name": "Liberian"
  },
  {
    "id": 101,
    "Name": "Libyan"
  },
  {
    "id": 102,
    "Name": "Liechtensteiner"
  },
  {
    "id": 103,
    "Name": "Lithuanian"
  },
  {
    "id": 104,
    "Name": "Luxembourger"
  },
  {
    "id": 105,
    "Name": "Macedonian"
  },
  {
    "id": 106,
    "Name": "Malagasy"
  },
  {
    "id": 107,
    "Name": "Malawian"
  },
  {
    "id": 108,
    "Name": "Malaysian"
  },
  {
    "id": 109,
    "Name": "Maldivian"
  },
  {
    "id": 110,
    "Name": "Malian"
  },
  {
    "id": 111,
    "Name": "Maltese"
  },
  {
    "id": 112,
    "Name": "Marshallese"
  },
  {
    "id": 113,
    "Name": "Mauritanian"
  },
  {
    "id": 114,
    "Name": "Mauritian"
  },
  {
    "id": 115,
    "Name": "Mexican"
  },
  {
    "id": 116,
    "Name": "Micronesian"
  },
  {
    "id": 117,
    "Name": "Moldovan"
  },
  {
    "id": 118,
    "Name": "Monacan"
  },
  {
    "id": 119,
    "Name": "Mongolian"
  },
  {
    "id": 120,
    "Name": "Moroccan"
  },
  {
    "id": 121,
    "Name": "Mosotho"
  },
  {
    "id": 122,
    "Name": "Motswana"
  },
  {
    "id": 123,
    "Name": "Mozambican"
  },
  {
    "id": 124,
    "Name": "Namibian"
  },
  {
    "id": 125,
    "Name": "Nauruan"
  },
  {
    "id": 126,
    "Name": "Nepalese"
  },
  {
    "id": 127,
    "Name": "New Zealander"
  },
  {
    "id": 128,
    "Name": "Ni-Vanuatu"
  },
  {
    "id": 129,
    "Name": "Nicaraguan"
  },
  {
    "id": 130,
    "Name": "Nigerian"
  },
  {
    "id": 131,
    "Name": "Nigerien"
  },
  {
    "id": 132,
    "Name": "North Korean"
  },
  {
    "id": 133,
    "Name": "Northern Irish"
  },
  {
    "id": 134,
    "Name": "Norwegian"
  },
  {
    "id": 135,
    "Name": "Omani"
  },
  {
    "id": 136,
    "Name": "Pakistani"
  },
  {
    "id": 137,
    "Name": "Palauan"
  },
  {
    "id": 138,
    "Name": "Panamanian"
  },
  {
    "id": 139,
    "Name": "Papua New Guinean"
  },
  {
    "id": 140,
    "Name": "Paraguayan"
  },
  {
    "id": 141,
    "Name": "Peruvian"
  },
  {
    "id": 142,
    "Name": "Polish"
  },
  {
    "id": 143,
    "Name": "Portuguese"
  },
  {
    "id": 144,
    "Name": "Qatari"
  },
  {
    "id": 145,
    "Name": "Romanian"
  },
  {
    "id": 146,
    "Name": "Russian"
  },
  {
    "id": 147,
    "Name": "Rwandan"
  },
  {
    "id": 148,
    "Name": "Saint Lucian"
  },
  {
    "id": 149,
    "Name": "Salvadoran"
  },
  {
    "id": 150,
    "Name": "Samoan"
  },
  {
    "id": 151,
    "Name": "San Marinese"
  },
  {
    "id": 152,
    "Name": "Sao Tomean"
  },
  {
    "id": 153,
    "Name": "Saudi"
  },
  {
    "id": 154,
    "Name": "Scottish"
  },
  {
    "id": 155,
    "Name": "Senegalese"
  },
  {
    "id": 156,
    "Name": "Serbian"
  },
  {
    "id": 157,
    "Name": "Seychellois"
  },
  {
    "id": 158,
    "Name": "Sierra Leonean"
  },
  {
    "id": 159,
    "Name": "Singaporean"
  },
  {
    "id": 160,
    "Name": "Slovakian"
  },
  {
    "id": 161,
    "Name": "Slovenian"
  },
  {
    "id": 162,
    "Name": "Solomon Islander"
  },
  {
    "id": 163,
    "Name": "Somali"
  },
  {
    "id": 164,
    "Name": "South African"
  },
  {
    "id": 165,
    "Name": "South Korean"
  },
  {
    "id": 166,
    "Name": "Spanish"
  },
  {
    "id": 167,
    "Name": "Sri Lankan"
  },
  {
    "id": 168,
    "Name": "Sudanese"
  },
  {
    "id": 169,
    "Name": "Surinamer"
  },
  {
    "id": 170,
    "Name": "Swazi"
  },
  {
    "id": 171,
    "Name": "Swedish"
  },
  {
    "id": 172,
    "Name": "Swiss"
  },
  {
    "id": 173,
    "Name": "Syrian"
  },
  {
    "id": 174,
    "Name": "Taiwanese"
  },
  {
    "id": 175,
    "Name": "Tajik"
  },
  {
    "id": 176,
    "Name": "Tanzanian"
  },
  {
    "id": 177,
    "Name": "Thai"
  },
  {
    "id": 178,
    "Name": "Togolese"
  },
  {
    "id": 179,
    "Name": "Tongan"
  },
  {
    "id": 180,
    "Name": "Trinidadian or Tobagonian"
  },
  {
    "id": 181,
    "Name": "Tunisian"
  },
  {
    "id": 182,
    "Name": "Turkish"
  },
  {
    "id": 183,
    "Name": "Tuvaluan"
  },
  {
    "id": 184,
    "Name": "Ugandan"
  },
  {
    "id": 185,
    "Name": "Ukrainian"
  },
  {
    "id": 186,
    "Name": "Uruguayan"
  },
  {
    "id": 187,
    "Name": "Uzbekistani"
  },
  {
    "id": 188,
    "Name": "Venezuelan"
  },
  {
    "id": 189,
    "Name": "Vietnamese"
  },
  {
    "id": 190,
    "Name": "Welsh"
  },
  {
    "id": 191,
    "Name": "Yemenite"
  },
  {
    "id": 192,
    "Name": "Zambian"
  },
  {
    "id": 193,
    "Name": "Zimbabwean"
  }
]
export default nationalities



// WEBPACK FOOTER //
// ./src/nationality.js